// 组件
import importImg from '@/components/importImg.vue'
// 接口
import * as addressesTypeApi from '@/services/address-types.js'
// 其他
import dataDictionary from '@/utils/data-dictionary.js'
import constant from '@/utils/constant.js'
import verifyRules from '@/utils/verify-rules/index.js'
import loading from '@/utils/loading.json'

export default {
  components: {
    importImg
  },
  data () {
    return {
      constant,
      dataDictionary,
      verifyRules: verifyRules(this),
      mainForm: {
        data: {
          name: null,
          name_en: null
        }
      }
    }
  },
  created () {
    const _this = this
    _this.urlParams = _this.$route.params
  },
  mounted () {
    const _this = this
    _this.setGlobalLoading(true)
    addressesTypeApi.getIdPreview(_this.urlParams.id).then(res => {
      _this.setGlobalLoading(false)
      const resData = res.data.address_type
      Object.assign(_this.mainForm.data, resData)
      return res
    }).catch(() => {
      _this.setGlobalLoading(false)
    })
  },
  methods: {
    setGlobalLoading (show) {
      const _this = this
      show ? _this.$store.state.app.loading = this.$loading(loading) : this.$store.state.app.loading.close()
    },
    handleMainFormCancelClick () {
      const _this = this
      _this.$router.go(-1)
    },
    handleMainFormSubmitClick () {
      const _this = this
      _this.$refs.mainForm.validate((valid) => {
        if (valid) {
          let requestParams = {}
          Object.assign(requestParams, _this.mainForm.data)
          requestParams = {
            address_type: {
              ...requestParams
            }
          }
          _this.setGlobalLoading(true)
          addressesTypeApi.putAddressTypesId(_this.urlParams.id, requestParams).then(() => {
            _this.setGlobalLoading(false)
            _this.$message({
              type: 'success',
              message: _this.$t('message.operateSuccess')
            })
            setTimeout(() => {
              _this.$router.push({
                name: 'buddyManagerAddressTypeList'
              })
            }, constant.ROUTER_CHANGE_INTERVAL)
          }).catch(() => _this.setGlobalLoading(false))
        }
      })
    }
  }
}
